module.exports = "/_next/static/images/6b62c7356289eafe0ad21918b21a8fae-apple-store.svg.webp";